import { PlusOutlined } from '@ant-design/icons';
import { Button, message, Tag } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import {
  DELETE_CONFIRM,
  DELETE_ERROR,
  FETCH_ERROR,
  REQUEST_LOADING,
  SUCCESS_DELETE,
} from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import { useEffect, useState } from 'react';
import { EdoAlertService } from 'services/EdoService';
import { ActionsWrapper } from 'ui/ActionsWrapper';
import { EdoAlertTable } from './EdoAlertTable';
import { EdoAlertForm, typeOfEdo } from './EdoAlertForm';

function EdoAlertConfig() {
  useDocumentTitle('Система уведомлений ЭДО');
  const { setCount } = useHeaderChanger('Система уведомлений ЭДО');

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { page, totalRows, perPage, setTotalRows, setPagination } =
    usePagination();
  const {
    state: { activeRecord, formIsActive, drawerVisible },
    openDrawer,
    closeDrawer,
    openEditForm,
    closeForm,
  } = useDrawers();

  useEffect(() => {
    fetchItems();
  }, [page, perPage]);

  const fetchItems = async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await EdoAlertService.getEdoAlert(page, perPage);

      setItems(items);
      setTotalRows(total);
      setCount(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isDeleted = await EdoAlertService.deleteEdoAlert(activeRecord.id);

      if (isDeleted) {
        closeDrawer();
        fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <>
      <ActionsWrapper placeEnd>
        <Button icon={<PlusOutlined />} type="primary" onClick={openEditForm}>
          Создать уведомление
        </Button>
      </ActionsWrapper>

      <EdoAlertTable
        items={items}
        loading={loading}
        pageSize={perPage}
        totalRows={totalRows}
        onChange={setPagination}
        onRowClick={openDrawer}
      />

      <RecordInfoDrawer
        pageId="alert"
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={[
          {
            label: 'Заголовок',
            key: 'title',
          },
          {
            label: 'Заголовок (Каз)',
            key: 'title_kz',
          },
          {
            label: 'Описание',
            key: 'description',
          },
          {
            label: 'Описание (Каз)',
            key: 'description_kz',
          },
          {
            label: 'Тип',
            dataIndex: 'alert_type',
            key: 'alert_type',
            // computedValue: (i) =>
            //   type.find((val) => val.value === i)?.text ?? 'Неизвестный тип',
          },
          {
            label: 'Разрешить подпись',
            dataIndex: 'allow_sign',
            key: 'allow_sign',
            computedValue: activeRecord?.allow_sign ? 'Да' : 'Нет',
          },
          {
            label: 'Страницы сайта',
            dataIndex: 'page_type',
            key: 'page_type',

            computedValue: activeRecord?.page_type.map(
              (i) =>
                (
                  <Tag key={i}>
                    {typeOfEdo.find((val) => val.value === i)?.text}
                  </Tag>
                ) ?? '---'
            ),
          },
          {
            label: 'Для всех сайтов',
            dataIndex: 'is_for_all',
            key: 'is_for_all',
            computedValue: activeRecord?.is_for_all ? 'Да' : 'Нет',
          },
        ]}
        isVisible={drawerVisible}
        onEdit={openEditForm}
        onDelete={handleDelete}
        onClose={closeDrawer}
        deleteConfirmText={DELETE_CONFIRM}
      />

      <EdoAlertForm
        isActive={formIsActive}
        initialValues={activeRecord}
        admins={[]}
        onSuccess={fetchItems}
        onClose={closeForm}
      />
    </>
  );
}

export { EdoAlertConfig };
